import PhotoSwipe from 'photoswipe';
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default.js';

export function initLightboxGallery(gallerySelector) {
	// parse slide data (url, title, size ...) from DOM elements
	// (children of gallerySelector)
	const parseThumbnailElements = function (el) {
		const items = [];

		let figureEl;
		let linkEl;
		let imgEl;
		let item;
		let size;

		const prepareItem = function (thumb) {
			figureEl = thumb;

			// include only element nodes
			if (figureEl.nodeType !== 1) {
				return;
			}

			linkEl = figureEl.getElementsByTagName('a')[0];

			if (!linkEl) {
				return;
			}

			imgEl = figureEl.getElementsByTagName('img')[0];

			size = imgEl.getAttribute('data-pswp-size').split('x');

			item = {
				src: linkEl.getAttribute('href'),
				w: parseInt(size[0], 10),
				h: parseInt(size[1], 10),
			};

			if (figureEl.children.length > 1) {
				item.title = figureEl.children[1].innerHTML;
			}

			item.el = figureEl; // save link to element for getThumbBoundsFn
			items.push(item);
		};

		// if a single figure
		if (el.tagName && el.tagName.toUpperCase() === 'FIGURE') {
			prepareItem(el);
		} else {
			const thumbElements = el.childNodes;
			const numNodes = thumbElements.length;

			for (let i = 0; i < numNodes; i++) {
				prepareItem(thumbElements[i]);
			}
		}

		return items;
	};

	// find nearest parent element
	const closest = function closest(el, fn) {
		return el && (fn(el) ? el : closest(el.parentNode, fn));
	};

	// triggers when user clicks on thumbnail
	const onThumbnailsClick = function (e) {
		e = e || window.event;
		e.preventDefault ? e.preventDefault() : (e.returnValue = false);

		const eTarget = e.target || e.srcElement;

		// find root element of slide
		const clickedListItem = closest(eTarget, function (el) {
			return el.tagName && el.tagName.toUpperCase() === 'FIGURE';
		});

		if (!clickedListItem) {
			return;
		}

		// find index of clicked item by looping through all child nodes
		// alternatively, you may define index via data- attribute
		const isGallery = clickedListItem.parentNode.className.indexOf('gallery') > -1;

		const clickedGallery = isGallery ? clickedListItem.parentNode : clickedListItem;
		const childNodes = isGallery ? clickedGallery.childNodes : null;

		if (!childNodes) {
			openPhotoSwipe(0, clickedGallery);
		} else {
			const numChildNodes = childNodes.length;
			let nodeIndex = 0;
			let index;

			for (let i = 0; i < numChildNodes; i++) {
				if (childNodes[i].nodeType !== 1) {
					continue;
				}

				if (childNodes[i] === clickedListItem) {
					index = nodeIndex;
					break;
				}
				nodeIndex++;
			}

			if (index >= 0) {
				// open PhotoSwipe if valid index found
				openPhotoSwipe(index, clickedGallery);
			}
		}

		return false;
	};

	// parse picture index and gallery index from URL (#&pid=1&gid=2)
	const photoswipeParseHash = function () {
		const hash = window.location.hash.substring(1);
		const params = {};

		if (hash.length < 5) {
			return params;
		}

		const lets = hash.split('&');
		for (let i = 0; i < lets.length; i++) {
			if (!lets[i]) {
				continue;
			}

			const pair = lets[i].split('=');
			if (pair.length < 2) {
				continue;
			}
			params[pair[0]] = pair[1];
		}

		if (params.gid) {
			params.gid = parseInt(params.gid, 10);
		}

		return params;
	};

	const openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
		const pswpElement = document.querySelectorAll('.pswp')[0];
		let gallery;

		const items = parseThumbnailElements(galleryElement);

		if (!items.length) {
			return;
		}

		// define options (if needed)
		const options = {
			// define gallery index (for URL)
			galleryUID: galleryElement.getAttribute('data-pswp-uid'),
			showHideOpacity: true,
			getThumbBoundsFn: false,
		};

		// PhotoSwipe opened from URL
		if (fromURL) {
			if (options.galleryPIDs) {
				// parse real index when custom PIDs are used
				// http://photoswipe.com/documentation/faq.html#custom-pid-in-url
				for (let j = 0; j < items.length; j++) {
					if (items[j].pid === index) {
						options.index = j;
						break;
					}
				}
			} else {
				// in URL indexes start from 1
				options.index = parseInt(index, 10) - 1;
			}
		} else {
			options.index = parseInt(index, 10);
		}

		// exit if index not found
		if (isNaN(options.index)) {
			return;
		}

		if (disableAnimation) {
			options.showAnimationDuration = 0;
		}

		// Pass data to PhotoSwipe and initialize it
		/* eslint-disable */
		gallery = new PhotoSwipe(pswpElement, PhotoSwipeUIDefault, items, options);
		/* eslint-enable */
		gallery.init();
		// Image loaded
		gallery.listen('imageLoadComplete', function (index, item) {
			item.container.classList.add('pswp__zoom-wrap--loaded');
		});
	};

	// loop through all gallery elements and bind events
	const galleryElements = document.querySelectorAll(gallerySelector);
	const uidStartingId = gallerySelector === '.gallery' ? 1 : 999;

	for (let i = 0, l = galleryElements.length; i < l; i++) {
		galleryElements[i].setAttribute('data-pswp-uid', i + uidStartingId);
		galleryElements[i].onclick = onThumbnailsClick;
	}

	// Parse URL and open gallery if it contains #&pid=3&gid=1
	const hashData = photoswipeParseHash();
	if (hashData.pid && hashData.gid && galleryElements[hashData.gid - uidStartingId]) {
		openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - uidStartingId], true, true);
	}
}
